(function (){
    'use strict';

    angular
        .module('services')
        .service('ExpensesService', ExpensesService);

    /* @ngInject */
    function ExpensesService ($http, $cacheFactory, API_BASE, Expense) {
        var service = this;

        // TODO: consider using $resource (https://docs.angularjs.org/api/ngResource/service/$resource)
        /* Expenses API */
        service.resources = {};

        /* Quick books */
        service.qboImport = qboImport;

        /* Expense repository methods */
        service.createExpense = createExpense;
        service.updateExpense = updateExpense;
        service.listExpenses = listExpenses;
        service.getExpenseById = getExpenseById;
        service.payExpenseById = payExpenseById;
        service.deleteExpenseById = deleteExpenseById;
        service.reverseExpenseById = reverseExpenseById;

        /* Other resources API */
        service.resources.expenses_currencies = `${Expense.API_RESOURCE}/currencies`;
        service.resources.expenses_payees = `${Expense.API_RESOURCE}/payees`;
        service.resources.expenses_payment_methods = `${Expense.API_RESOURCE}/payment_methods`;
        service.resources.expenses_bank_accounts = `${Expense.API_RESOURCE}/bank_accounts`;
        service.resources.expenses_items = `${Expense.API_RESOURCE}/items`;
        service.resources.expenses_items_categories = `${service.resources.expenses_items}/categories`;
        service.resources.expenses_items_semesters = `${service.resources.expenses_items}/semesters`;
        service.resources.expenses_items_cost_centers = `${API_BASE}/cost_centers/all`;
        
        // TODO: consider extracting to it's own services/models
        /* Other resources methods */
        service.listExpenseCurrencies = listExpenseCurrencies;
        service.listExpensePayees = listExpensePayees;
        service.listExpensePaymentMethods = listExpensePaymentMethods;
        service.listExpenseBankAccounts = listExpenseBankAccounts;
        service.listExpenseItemCategories = listExpenseItemCategories;
        service.listExpenseItemSemesters = listExpenseItemSemesters;
        service.listExpenseItemCostCenters = listExpenseItemCostCenters;

        // Other resources cache
        service.otherResourcesCache = $cacheFactory('otherResources');
        
        // TODO: think of a better place for pagination related data
        // Expenses Pagination
        service.expenses = [];
        service.totalItems = 0;
        service.to = 0;
        service.itemsPerPage = 0;



        service.getExpenseSemesters     = getExpenseSemesters;
        service.getExpenseAccounts      = getExpenseAccounts;
        service.getExpenses             = getExpenses;
        service.getCostCentersForSelect = getCostCentersForSelect;
        service.getCategoriesForSelect  = getCategoriesForSelect;
        service.getExpensesComparative  = getExpensesComparative;


        function createExpense (data) {
            var expense = prepareData(data);

            return expense.save();
        }

        function updateExpense (id, data) {
            var expense = new Expense({id});

            return expense.update(prepareData(data));
        }
        
        function listExpenses (query) {
            return Expense.where(query)
                // TODO: Improve this
                .then(res => {
                    service.expenses = res.data.data;
                    service.totalItems = res.data.total;
                    service.to = res.data.to;
                    service.itemsPerPage = res.data.per_page;
                    service.currentPage = res.data.current_page;

                    return service;
                });
        } 

        function getExpenseById (id) { 
            return Expense.find(id)
                .catch(err => null);
        }
    
        // TODO: Extract to model
        function reverseExpenseById (id) {
            if (id.constructor === Array) {
                return $http.post(`${Expense.API_RESOURCE}/reverse`, {
                        ids: id 
                    }, Expense.API_OPTIONS);
            }
            else {
                return $http.post(`${Expense.API_RESOURCE}/${id}/reverse`, null, Expense.API_OPTIONS);            
            }
        }
        
        // TODO: Extract to model
        function payExpenseById (id, data) { 
            if (id.constructor === Array) {
                return $http.post(`${Expense.API_RESOURCE}/pay`, {
                    ids: id,
                    ...data
                }, { 
                    header : { 'Content-Type': 'application/json; charset=UTF-8' }, 
                });
            }
            else {
                return $http.post(`${Expense.API_RESOURCE}/${id.id}/pay`, data, {
                    header : { 'Content-Type': 'application/json; charset=UTF-8' }, 
                });
            }
        }
    
        // TODO: Extract to model
        function deleteExpenseById (id) { 
            if (id.constructor === Array) {
                return $http.post(`${Expense.API_RESOURCE}/delete`, {
                        ids: id 
                    }, { 
                        header : { 'Content-Type': 'application/json; charset=UTF-8' }, 
                    });
            } else {
                return $http.delete(`${Expense.API_RESOURCE}/${id}`, {
                        header : { 'Content-Type': 'application/json; charset=UTF-8' }, 
                    });
            }
        }
        
        function listExpenseCurrencies() {
            return listOtherResource(service.resources.expenses_currencies);
        }
    
        function listExpensePayees() {
            return listOtherResource(service.resources.expenses_payees);
        }
    
        function listExpensePaymentMethods() {
            return listOtherResource(service.resources.expenses_payment_methods);
        }
        
        function listExpenseBankAccounts() {
            return listOtherResource(service.resources.expenses_bank_accounts);
        }
    
        function listExpenseItemCategories() {
            return listOtherResource(service.resources.expenses_items_categories);
        }
    
        function listExpenseItemSemesters() {
            return listOtherResource(service.resources.expenses_items_semesters);
        }
    
        function listExpenseItemCostCenters() {
            return listOtherResource(service.resources.expenses_items_cost_centers);
        }

        function listOtherResource(resource) {
            var cachedItems = service.otherResourcesCache.get(resource);

            if (cachedItems) {
                return cachedItems; 
            } 
            else {
                return $http.get(resource, {
                    header: { 'Content-Type': 'application/json; charset=UTF-8' },
                })
                .then(res => {
                    var resourceItems = res.data;
                    service.otherResourcesCache.put(resource, res.data);
                    return resourceItems;
                })
                .catch(err => null)            
            }
        }

        function qboImport() {
            if (service.otherResourcesCache) {
                service.otherResourcesCache.removeAll();
            }

            return $http.post(`${Expense.API_RESOURCE}/qbo-import`, null, Expense.API_OPTIONS);       
        }

        function prepareData(data) {
            var expense = new Expense();

            expense.due_date = moment(data.due_date).format('YYYY-MM-DD 00:00:00');
            expense.payee_id = data.payee && data.payee.id;
            expense.currency = data.currency;
            
            for (var item of data.items) {
                expense.items.push({
                    id:  item.id,
                    account_id:  item.account && item.account.id,
                    cost_center_id: item.cost_center && item.cost_center.id,
                    semester_id: item.semester && item.semester.id,
                    description: item.description,
                    total: item.total,
                    deleted: item.deleted,
                }); 
            }

            if (data.recurring) {
                expense.due_date = [expense.due_date];

                for (var due_date of data.recurringDueDates) {
                    expense.due_date.push(moment(due_date).format('YYYY-MM-DD 00:00:00'));
                }
            }
            else if (data.paid) {
                expense.payment_date = moment(data.payment_date).format('YYYY-MM-DD 00:00:00');
                expense.payment_method_id = data.payment_method && data.payment_method.id;
                expense.account_id = data.account.id;
                expense.additions = data.additions;
                expense.discounts = data.discounts;
            }
            else {
                expense.payment_date = null;
                expense.payment_method_id = null;
                expense.account_id = null;
                expense.additions = null;
                expense.discounts = null;
            }

            return expense;
        }

        function getExpenseSemesters(query) {
            return $http.get(API_BASE + '/expenses/semesters/select', {params: query});
        }
        function getExpenseAccounts(query) {
            return $http.get(API_BASE + '/expenses/accounts/select', {params: query});
        }
        function getExpenses(query) {
            return $http.get(API_BASE + '/expenses/list', {params: query});
        }
        function getCostCentersForSelect(query) {
            return $http.get(API_BASE + '/cost_centers/list', {params: query});
        }
        function getCategoriesForSelect(query) {
            return $http.get(API_BASE + '/expenses/categories', {params: query});
        }
        function getExpensesComparative(query) {
            return $http.get(API_BASE + '/expenses/comparative', {params: query});
        }
    }
})();